import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2BD05FF6-4E09-40EC-9D34-59FB9CCD09FF
 * name flask-round-bottom-empty-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flask-round-bottom-empty-outline.svg
 * tags
 * - Science 
 */
export const FlaskRoundBottomEmptyOutlineIcon = createSvgIcon(<><path d="M19 15C19 18.87 15.87 22 12 22C8.13 22 5 18.87 5 15C5 12.21 6.64 9.8 9 8.67V5C9 4.45 9.45 4 10 4H10.5L9.5 2H14.5L13.5 4H14C14.55 4 15 4.45 15 5V8.67C17.36 9.8 19 12.21 19 15M11 6V10.1C8.72 10.56 7 12.58 7 15C7 17.76 9.24 20 12 20C14.76 20 17 17.76 17 15C17 12.58 15.28 10.56 13 10.1V6H11Z" /></>, 'FlaskRoundBottomEmptyOutlineIcon');
export default FlaskRoundBottomEmptyOutlineIcon